import React, { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { createReport } from "../../../apis/reports";
import { PregnancyFormInputs } from "../../../util/reportsCreation/report.formHelper";
import { downloadPregnancyReport } from "../../../util/reportsCreation/pregnancyReportPdf";
import PrimaryButton from "../../buttons/PrimaryButton";
import TextInput from "../../fromComponents/TextInput";
import {
  getNameValueObject,
  objectBuilderForPDF,
} from "../../../util/data.util";
import { ReportObjCreator } from "../../../util/api.helpers";
import { NEED_TO_UPDATE, PREGNANCY_SCAN } from "../../../constants/Constants";
import { useDispatch, useSelector } from "react-redux";
import { todaysDate } from "../../../util/getTodaysDate";
import ComponentLoading from "../../loading/ComponentLoading";
import AddDownload from "../../OptionsComponents/AddDownload";
import useSnackbar from "../../../hooks/useSnackbar";
import {
  CREATE_FAILED,
  CREATE_SUCCESS,
  DOWNLOAD_FAILED,
  DOWNLOAD_SUCCESS,
} from "../../../constants/SnackbarMessages";
import TextInputFull from "../../fromComponents/TextInputFull";
import { setProgressNotes } from "../../../redux/slice/progressNotesSlice";

export const PregnancyReport = React.memo(() => {
  const patientObject: any = useSelector<PatientState>(
    (state) => state.patient
  );
  const { patient } = patientObject;
  const partnerObject: any = useSelector<PartnerState>(
    (state) => state.partner
  );
  const { partner } = partnerObject;
  const userObject: any = useSelector<UserState>((state) => state.user);
  const { signature } = userObject.user.staff;
  const [reportObj, setReportObj] = useState<PregnancyScanType>();
  const { register, handleSubmit, reset } = useForm<PregnancyScanType>();
  const [isDisable, setIsDisable] = useState<boolean>(true);
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const { successSnackbar, errorSnackbar } = useSnackbar();
  const progressNotes: any = useSelector<ProgressNotesState>(
    (state) => state.progressNotes
  );
  const dispatch = useDispatch();

  const onSubmit = async (patientData: PregnancyScanType) => {
    setIsLoading(!isLoading);
    patientData.reportDate = todaysDate();
    patientData.signature = signature;
    setReportObj(
      objectBuilderForPDF(
        patient,
        patient.partnerPublicId ? partner : null,
        patientData
      )
    );
  };

  const handleDownload = async () => {
    if (reportObj) {
      await downloadPregnancyReport(reportObj);
      handleReset();
      successSnackbar(DOWNLOAD_SUCCESS);
    } else {
      errorSnackbar(DOWNLOAD_FAILED);
    }
  };
  const createNewReport = async () => {
    if (reportObj) {
      const values = getNameValueObject(reportObj);
      const [response, error] = await createReport(
        ReportObjCreator(
          PREGNANCY_SCAN,
          reportObj.patientId,
          reportObj.patientName,
          reportObj.patientDOB,
          values
        )
      );
      if (response) {
        successSnackbar(`Report ${CREATE_SUCCESS}`);
        setIsDisable(false);
        setIsLoading(false);
        dispatch(setProgressNotes([...progressNotes.data, response]));
      } else {
        errorSnackbar(`${CREATE_FAILED} Report.${error}`);
      }
      setIsLoading(false);
    }
  };

  const handleReset = () => {
    reset(); // Reset the form fields
    setIsDisable(true);
    setReportObj(undefined);
  };

  useEffect(() => {
    createNewReport();
  }, [reportObj]);

  return isDisable ? (
    <>
      {isLoading ? (
        <ComponentLoading />
      ) : (
        <div className="col-sm-12 mb-5">
          <div className="col-sm-12 p-3">
            <h3 className="text-center">Pregnancy Scan Report</h3>
          </div>
          <form onSubmit={handleSubmit(onSubmit)}>
            <div className="col-sm-12 p-2">
              <div className="row ms-1">
                {PregnancyFormInputs.map((item: InputFieldType) => {
                  return item.id !== "additionalComments" ? (
                    <TextInput
                      keyName={item.id}
                      register={register}
                      placeholder={item.placeholder}
                      id={item.id}
                      label={item.label}
                      type={item.type}
                      listName={item.id + "list"}
                      options={item.options}
                      required={item.required}
                      tag={item.tag}
                      maxLength={item.maxLength}
                      minRows={item.minRows}
                    />
                  ) : (
                    <TextInputFull
                      keyName={item.id}
                      register={register}
                      placeholder={item.placeholder}
                      id={item.id}
                      label={item.label}
                      type={item.type}
                      listName={item.id + "list"}
                      options={item.options}
                      required={item.required}
                      tag={item.tag}
                      maxLength={item.maxLength}
                      minRows={item.minRows}
                    />
                  );
                })}
              </div>
            </div>

            <PrimaryButton label={"Save"} type={"submit"} className={""} />
          </form>
        </div>
      )}
    </>
  ) : (
    <AddDownload onDownload={handleDownload} onReset={handleReset} />
  );
});
